/** @format */
import React from 'react'

export default function Cell({ value, classes }) {
  const _classes = `${classes} cell`
  return <div className={_classes}>{value}</div>
}



// WEBPACK FOOTER //
// ./ui/DatePicker/cell.js